import React, { useState, useEffect } from 'react';
import '../../../urunDiv.css';
import suResim from '../../../../assets/menu/icecekler/mesrubatlar/su.jpeg';
import sadeSodaResim from '../../../../assets/menu/icecekler/mesrubatlar/sade-soda.jpeg';
import limonluSodaResim from '../../../../assets/menu/icecekler/mesrubatlar/limonlu-soda.jpeg';
import elmalıSodaResim from '../../../../assets/menu/icecekler/mesrubatlar/elmalı-soda.jpeg';
import redBullResim from '../../../../assets/menu/icecekler/mesrubatlar/red-bull.jpeg';
import iceTeaSeftaliResim from '../../../../assets/menu/icecekler/mesrubatlar/ice-tea-seftali.jpeg';
import iceTeaLimonResim from '../../../../assets/menu/icecekler/mesrubatlar/ice-tea-limon.jpeg';
import iceTeaMangoResim from '../../../../assets/menu/icecekler/mesrubatlar/ice-tea-mango.jpeg';
import cappyVisneResim from '../../../../assets/menu/icecekler/mesrubatlar/cappy-visne.jpeg';
import cappySeftaliResim from '../../../../assets/menu/icecekler/mesrubatlar/cappy-seftali.jpeg';
import cappyKarisikResim from '../../../../assets/menu/icecekler/mesrubatlar/cappy-karisik.jpeg';
import spriteResim from '../../../../assets/menu/icecekler/mesrubatlar/sprite.jpeg';
import cocaColaResim from '../../../../assets/menu/icecekler/mesrubatlar/coca-cola.jpeg';
import fantaResim from '../../../../assets/menu/icecekler/mesrubatlar/fanta.jpeg';
import churchillResim from '../../../../assets/menu/icecekler/mesrubatlar/churchill.jpeg';

const Mesrubatlar = () => {
  const [isPhone, setIsPhone] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsPhone(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const kahveKategorileri = {
    'Su ve Sodalar': [
      {
        id: 1,
        name: 'Su',
        price: '₺59,90',
        image: suResim
      },
      {
        id: 2,
        name: 'Sade Soda',
        price: '₺89,90',
        image: sadeSodaResim
      },
      {
        id: 3,
        name: 'Limonlu Soda',
        price: '₺89,90',
        image: limonluSodaResim
      },
      {
        id: 4,
        name: 'Elmalı Soda',
        price: '₺89,90',
        image: elmalıSodaResim
      }
    ],
    'Enerji İçecekleri': [
      {
        id: 5,
        name: 'Red Bull',
        price: '₺200,00',
        image: redBullResim
      }
    ],
    'Soğuk Çaylar': [
      {
        id: 6,
        name: 'Ice Tea Şeftali',
        price: '₺119,90',
        image: iceTeaSeftaliResim
      },
      {
        id: 7,
        name: 'Ice Tea Limon',
        price: '₺119,90',
        image: iceTeaLimonResim
      },
      {
        id: 8,
        name: 'Ice Tea Mango',
        price: '₺119,90',
        image: iceTeaMangoResim
      }
    ],
    'Meyve Suları': [
      {
        id: 9,
        name: 'Cappy Vişne',
        price: '₺119,90',
        image: cappyVisneResim
      },
      {
        id: 10,
        name: 'Cappy Şeftali',
        price: '₺119,90',
        image: cappySeftaliResim
      },
      {
        id: 11,
        name: 'Cappy Karışık',
        price: '₺119,90',
        image: cappyKarisikResim
      }
    ],
    'Gazlı İçecekler': [
      {
        id: 12,
        name: 'Sprite',
        price: '₺119,90',
        image: spriteResim
      },
      {
        id: 13,
        name: 'Coca Cola/Zero',
        price: '₺119,90',
        image: cocaColaResim
      },
      {
        id: 14,
        name: 'Fanta',
        price: '₺119,90',
        image: fantaResim
      }
    ],
    'Diğer İçecekler': [
      {
        id: 15,
        name: 'Churchill',
        price: '₺119,90',
        image: churchillResim
      }
    ]
  };



  return (
    isPhone ? (
      <div className="urun-container">
        <div className="container" style={{marginTop: '20px'}}>
          <h2 style={{marginTop: '0px', marginLeft: 'auto', fontWeight: '700' }}>Meşrubatlar</h2>
        </div>
        
        {Object.entries(kahveKategorileri).map(([kategori, kahveler]) => (
          <div key={kategori}>
            <div className="container" style={{marginTop: '20px'}}>
              <h2 style={{marginLeft: 'auto', fontWeight: '700', marginTop: '0px' }}>{kategori}</h2>
            </div>
            <hr style={{color: '#D8D8D8'}} />
            <div className="urun-grid">
              {kahveler.map((kahve) => (
                <div 
                  key={kahve.id} 
                  className="urun-kart"
                >
                  <div className="urun-bilgi">
                    <h3 className="urun-ad">{kahve.name}</h3>
                    <div className="urun-fiyat">{kahve.price}</div>
                  </div>
                  <div className="urun-resim">
                    <img src={kahve.image} alt={kahve.name} style={{
                      width: '80px',
                      height: '80px',
                      objectFit: 'cover',
                      borderRadius: '100px',
                    }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    ) : (
      <div className="urun-container">
        <div className="container" style={{marginTop: '20px'}}>
          <h2 style={{marginTop: '0px', marginLeft: 'auto', fontWeight: '700' }}>Meşrubatlar</h2>
        </div>
        
        {Object.entries(kahveKategorileri).map(([kategori, kahveler]) => (
          <div style={{marginBottom: '80px'}} key={kategori}>
            <div className="container" style={{marginTop: '20px'}}>
              <h2 style={{marginLeft: 'auto', fontWeight: '700', marginTop: '0px' }}>{kategori}</h2>
            </div>
            <hr style={{color: '#D8D8D8'}} />
            <div className="urun-grid-computer">
              {kahveler.map((kahve) => (
                <div 
                  key={kahve.id} 
                  className="urun-kart-computer"
                >
                  <div className="urun-bilgi">
                    <h3 className="urun-ad-computer">{kahve.name}</h3>
                    <div className="urun-fiyat-computer">{kahve.price}</div>
                  </div>
                  <div className="urun-resim">
                    <img src={kahve.image} alt={kahve.name} style={{
                      width: '100px',
                      height: '100px',
                      objectFit: 'cover',
                      borderRadius: '100px',
                    }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    )
  );
};

export default Mesrubatlar;
